import '../assets/scss/main.scss'

import Menu from './Menu/Menu'
import ProgressBar from './ProgressBar/ProgressBar'
import Step from './Step/Step'
import styled from './Stepper.module.scss'
import DesktopTop from './DesktopTop/DesktopTop'
import ButtonFooter from './ButtonFooter/ButtonFooter'
import { observer } from 'mobx-react-lite'
import { useStore } from '../module/rootStore'
import Spinner from './Spinner/Spinner'
// import Logo from '../assets/logo-dark.svg'

const Logo = 'https://b.creditsfast.com/themes/creditsfast/images/logo-dark.svg'
const Stepper = () => {
  const { StepsStore } = useStore()
  return (
    <div className={styled.container}>
      {StepsStore.showSpinner && <Spinner />}
      <DesktopTop />
      {StepsStore.isLoading && (
        <div className={styled.wrapper}>
          {/* <img className={styled.logo} src={Logo} /> */}
          <Menu />
          <div className={styled.body}>
            <ProgressBar />
            <Step />
            <ButtonFooter isBankAccount={StepsStore.stepsSetting[StepsStore.currentStep].bankSsl} />
          </div>
        </div>
      )}
    </div>
  )
}

export default observer(Stepper)
